
// react imports
import * as React from 'react';
import injectSheet from "react-jss";

// material components
import Stack from '@mui/material/Stack';

// styles
import styles from './stack_styles.js';
import StackItem from "./stackitem/stackitem";


/* ========== ~~~~~~~~~~ REPORT BUILDER / CREATE NEW REPORT ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) => {{
    const { items , handleDeletion } = props;
    const handleRemoval = (item) => {
        handleDeletion(item.value);
    }
    return (
        <div className={`${props.classes.stack} stack`}>
            <Stack
                direction={{ xs: 'row', sm: 'column' }}
                spacing={{ xs: 1, sm: 2, md: 4 }}
            >
                {items.map(item =>
                    <StackItem item={item} handleDeletion={(item) => handleRemoval(item)}></StackItem>
                )}
            </Stack>
        </div>
    );
}})